export default {
  tourUi: {
    loading: 'Carregando passeio...',
    status: {
      unavailable: 'Indisponível',
    },
    backToTours: 'Voltar aos passeios',
    seo: {
      keywordPrefix: 'passeio Paraty',
      breadcrumbHome: 'Início',
      breadcrumbTours: 'Passeios',
      touristTypes: ['Família', 'Casal', 'Aventura'],
    },
    gallery: {
      expand: 'Ampliar imagem',
      close: 'Fechar',
      photoAlt: '{{title}} - foto {{n}}',
      thumbAlt: '{{title}} - miniatura {{n}}',
    },
    booking: {
      pixDeposit: 'Sinal via PIX',
      remaining: 'Restante no dia',
      depositNote: 'Sinal de {{rate}}% do total, com mínimo de R$ 20,00.',
      depositFixedPerson: 'Sinal de {{amount}} por pessoa.',
      depositFixedBooking: 'Sinal fixo de {{amount}} por reserva.',
      depositMixed: 'O sinal soma o valor de cada passeio (porcentagem ou valor fixo), com mínimo de R$ 20,00.',
      fullNote: 'O valor total do passeio é pago agora para garantir a reserva.',
      minDate: 'Escolha uma data a partir de {{date}}.',
      seatsLeft_one: 'Restam apenas {{count}} vaga(s) disponíveis para este passeio.',
      seatsLeft_other: 'Restam apenas {{count}} vaga(s) disponíveis para este passeio.',
      decrease: 'Diminuir {{label}}',
      increase: 'Aumentar {{label}}',
    },
  },
};
